import TituloService from "@/api/services/personal/nomencladores/TituloService"
import Vue from "vue"

const state = () => ({
    titulos: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "nombre",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    TITULOS: state => {
        return state.titulos
    },
    TITULOS_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_TITULOS: (state, payload) => {
        state.titulos = payload
    },

    SET_TITULOS_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_TITULO: (state, payload) => {
        state.titulos.push(payload)
    },

    UPDATE_TITULO: (state, payload) => {
        state.titulos = state.titulos.map(el => (el.id === payload.id ? payload : el))
    },

    DELETE_TITULO: (state, payload) => {
        state.titulos = state.titulos.filter(el => el.id !== payload.id)
    }
}

const actions = {
    LOAD_TITULOS: async ({ commit, state }, { filter, tituloEstado }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }
            let { data, status, headers } = await TituloService.get({ filter, tituloEstado, ...pagination })
            if (status === 200) {
                commit("SET_TITULOS", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los títulos, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_TITULOS: async ({ commit }) => {
        try {
            let { data, status } = await TituloService.getAll()
            if (status === 200) {
                commit("SET_TITULOS", data)
                return data
            }
        } catch (error) {
            if (error.response) {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_ALL_RECORDS_TITULOS: async ({ commit }) => {
        try {
            let { data, status } = await TituloService.getAllRecords()
            if (status === 200) {
                commit("SET_TITULOS", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar los títulos, inténtelo nuevamente"
            })
        }
    },

    LOAD_HISTORY_TITULO: async ({ commit }, payload) => {
        try {
            let { data, status } = await TituloService.getHistory(payload)
            if (status === 200) {
                commit("UPDATE_TITULO", data)
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar el historial del título, inténtelo nuevamente"
            })
        }
    },

    ADD_TITULO: async ({ commit }, payload) => {
        try {
            let { data, status } = await TituloService.post(payload)
            if (status === 201) {
                commit("ADD_TITULO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "El título ha sido agregado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar el título, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_TITULO: async ({ commit }, payload) => {
        try {
            let { data, status } = await TituloService.put(payload)
            if (status === 200) {
                commit("UPDATE_TITULO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "El título ha sido modificado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar el título, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    DELETE_TITULO: async ({ commit }, payload) => {
        try {
            let { status, data } = await TituloService.delete(payload)
            if (status === 204) {
                commit("DELETE_TITULO", payload)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Eliminando",
                    text: "El título ha sido eliminado satisfactoriamente"
                })
            }
            if (status === 200) {
                commit("UPDATE_TITULO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Deshabilitando",
                    text: "El título ha sido deshabilitado satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido eliminar/deshabilitar el historial del título, inténtelo nuevamente"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
